import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PayWithPointsService } from '@shared/services/pay-with-points.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PayWithPointsActions } from './pay-with-points.actions';

@Injectable()
export class PayWithPointsEffects {
  public getTotalBalance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayWithPointsActions.getBalance),
      switchMap(() => {
        return this.payWithPointsService.getPoints().pipe(
          map((points) => ({ type: PayWithPointsActions.getBalanceSuccess, points })),
          catchError(() => of({ type: PayWithPointsActions.getBalanceFail }))
        );
      })
    )
  );

  constructor(private actions$: Actions, private payWithPointsService: PayWithPointsService) {}
}
